/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proxy_Random_DeckInputs */



/**
* | output |
* | --- |
* | "Random" |
*
* @param {Proxy_Random_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const proxy_random_deck = /** @type {((inputs?: Proxy_Random_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proxy_Random_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aléatoire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aleatorio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aleatório")
	if (locale === "it") return /** @type {LocalizedString} */ ("Casuale")
	return /** @type {LocalizedString} */ ("Random")
});